import React from 'react';
import { Avatar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { isEmpty, last } from 'lodash';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { instanceOf } from 'prop-types';

function UserDetails({ mentorData }) {
  const {
    present_picture: presentPicture,
    full_name: name,
    linkedin_url: linkedin,
    introduction,
    employment,
  } = mentorData;

  return (
    <div className="user-info-wrapper">
      <Avatar
        className="mentor-details-avatar"
        src={presentPicture}
        icon={<FontAwesomeIcon icon={faUser} />}
        shape="square"
        size={120} />
      <h5 className="arc-H250 mt16">{name}</h5>
      <If condition={!isEmpty(employment)}>
        <div className="mt6">
          <span className="arc-p">
            <If condition={last(employment).designation}>
              {last(employment).designation}
              {' '}
              at
              {' '}
            </If>
            {last(employment).employer}
          </span>
        </div>
      </If>
      <If condition={linkedin}>
        <a href={linkedin} className="arc-color-gray7 mt8">
          <FontAwesomeIcon icon={faLinkedin} />
        </a>
      </If>
      <If condition={introduction}>
        <p className="arc-p pb16 mt16">{introduction}</p>
      </If>
    </div>
  );
}

UserDetails.propTypes = {
  mentorData: instanceOf(Object).isRequired,
};

export default UserDetails;
